export const CHECK_EMAIL_STEP_TITLE = 'Check your inbox'
export const CHECK_EMAIL_STEP_DESCRIPTION = 'An email is on its way to activate your account.'
/** Registration check-email fallback support line; page-content/authLabels should override per brand. */
export const CHECK_EMAIL_STEP_ADDITIONAL_INFO_DEFAULT = 'If you don’t get an email within 24 hours, or if your activation link has expired, please call toll-free at 866-271-6192.'
/** @deprecated Use CHECK_EMAIL_STEP_ADDITIONAL_INFO_DEFAULT as fallback for CMS-driven content. */
export const CHECK_EMAIL_STEP_ADDITIONAL_INFO = CHECK_EMAIL_STEP_ADDITIONAL_INFO_DEFAULT
export const CHECK_EMAIL_STEP_BUTTON_TEXT = 'Back to sign in'
